
const types = {
  base: 'BaseLeadTypeDefault',
  product: 'BaseLeadTypeProduct',
}

export default {
  name: 'BaseLead',
  props: {
    lead: {
      type: Object,
      default: null,
    },
    sendBtnText: {
      type: String,
      default: 'Отправить',
    },
    successText: {
      type: String,
      default: 'Форма успешно отправленна',
    },
    type: {
      type: String,
      default: 'base',
      validator: (value) => {
        return Object.keys(types).includes(value)
      },
    },
    theme: {
      type: String,
      default: 'light',
    },
  },

  computed: {
    currentType() {
      return types[this.type]
    },
  },
}
